const isChecked = (data) => {
  return data.value === true ? true : "this field is required";
}

export default isChecked;
